<template>
  <div class="store-table">
    <!--新增/删除按钮-->
    <vxe-toolbar size="mini" v-if="!isHiddenBtn">
      <template v-slot:buttons>
        <template>
          <el-button type="primary" size="small" class="vxe-btn-primary" @click="addNewRowHandler"
            >新增</el-button
          >
          <el-button
            size="small"
            type="danger"
            class="vxe-btn-delete"
            @click="deleteBtnClickHandler()"
            >删除</el-button
          >
        </template>
      </template>
    </vxe-toolbar>
    <!---可编辑表格-->
    <vxe-grid
      border
      show-overflow
      resizable
      ref="xTableRef"
      class="vxe-table-element"
      size="mini"
      align="left"
      :auto-resize="true"
      :data="tableData"
      :columns="tableColumnsList"
      :edit-rules="tableRules"
      :edit-config="editConfig"
      :valid-config="{ autoPos: true, message: 'inline' }"
      :show-footer="true"
      @select-change="handleSelectionChange"
      @select-all="handleSelectionChange"
    >
    </vxe-grid>
    <ViewImgDialog ref="viewImgDialogRef" />
  </div>
</template>

<script>
  import ViewImgDialog from './components/ViewImgDialog.vue';
  export default {
    name: 'ContractTable',
    props: {
      contractStatus: {
        type: String,
        default: '',
      },
      fetchTableData: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        tableData: [],
        selectionList: [],
        editConfig: { trigger: 'click', mode: 'row' },
        isHiddenBtn: false,
        tableRules: {
          companyName: [{ required: true, message: '仓库公司必填', trigger: ['change', 'blur'] }],
          storageName: [{ required: true, message: '仓库名称必填', trigger: ['change', 'blur'] }],
          storageNo: [{ required: true, message: '仓库编码必填', trigger: ['change', 'blur'] }],
          // storageAddress: [{ required: true, message: '仓库地址必填', trigger: 'blur' }],
        },
        ids: [], // 被删除的数据id集合
      };
    },
    computed: {
      tableColumnsList() {
        return [
          { type: 'checkbox', width: 50 },
          { type: 'seq', title: '序号', width: 50 },
          {
            field: 'companyName',
            title: '仓库公司',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{row['companyName']}</span>];
              },
              edit: ({ row }) => {
                return [
                  <SearchTable
                    searchType="warehouseCompany"
                    isMultiple={true}
                    currentValue={row['companyName']}
                    checkRowKeys={[row['companyCode']]}
                    onInput={(val) => this.chooseTable(val, row, 'companyName')}
                  ></SearchTable>,
                ];
              },
            },
            width: 150,
          },
          {
            field: 'storageName',
            title: '仓库名称',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
                disabled: true,
              },
            },
            width: 150,
            // slots: {
            //   default: ({ row }) => {
            //     return [<span>{row['storageName']}</span>];
            //   },
            //   edit: ({ row }) => {
            //     return [
            //       <SearchTable
            //         searchType="warehouse"
            //         isMultiple={true}
            //         onInput={(val) => this.chooseTable(val, row, 'storageName')}
            //       ></SearchTable>,
            //     ];
            //   },
            // },
          },
          {
            field: 'storageAddress',
            title: '仓库地址',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
                placeholder: '请输入仓库地址',
              },
            },
            width: 150,
          },
          {
            field: 'storageNo',
            title: '仓库编号',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
                disabled: true,
              },
            },
            width: 150,
          },
          {
            field: 'storageArea',
            title: '库区',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            width: 150,
          },
          {
            field: 'storageLocation',
            title: '库位',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            width: 150,
          },
          {
            field: 'storageFloor',
            title: '楼层',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            width: 150,
          },
          {
            field: 'remark',
            title: '备注',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            width: 150,
          },
          {
            field: 'storagePic',
            title: '图片上传',
            editRender: {},
            slots: {
              default: ({ row }) => {
                return [
                  <div>
                    {row['storagePic'] && (
                      <img
                        src={row['storagePic']}
                        alt=""
                        style={{ width: '50px', height: '50px', cursor: 'pointer' }}
                        onClick={() => this.openViewImgDialog(row['storagePic'])}
                      />
                    )}
                  </div>,
                ];
              },
              edit: ({ row }) => {
                return [
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    {row['storagePic'] && (
                      <img
                        src={row['storagePic']}
                        alt=""
                        style={{
                          width: '50px',
                          height: '50px',
                          cursor: 'pointer',
                          marginRight: '10px',
                        }}
                        onClick={() => this.openViewImgDialog(row['storagePic'])}
                      />
                    )}
                    <IELUploadBtn
                      fileType={['png', 'gif', 'jpeg', 'jpg']}
                      uploadHandler={(result) => this.uploadHandler(result, row)}
                    />
                  </div>,
                ];
              },
            },
            width: 150,
          },
        ];
      },
    },
    methods: {
      chooseTable(val, row, prop) {
        console.log(val, row, prop);
        const selectRowData = val[0];
        if (prop == 'companyName') {
          row['companyName'] = selectRowData.companyName;
          row['companyNo'] = selectRowData.companyCode;
          row['storageName'] = selectRowData.storageName;
          row['departmentName'] = selectRowData.departmentName;
          row['departmentCode'] = selectRowData.departmentCode;
          row['storageNo'] = selectRowData.storageCode;
          row['storageAddress'] = selectRowData.storageAddress;
        }
      },
      // 预览图片
      openViewImgDialog(imgUrl) {
        this.$refs.viewImgDialogRef.openDialog(imgUrl);
      },
      uploadHandler(result, row) {
        console.log(result, row);
        // 调用接口上传
        row['storagePic'] = result['attachmentPath'];
      },
      handleSelectionChange(row) {
        this.selectionList = row.selection;
      },
      // 新增一行
      async addNewRowHandler() {
        const $table = this.$refs.xTableRef;
        const { row } = await $table.insertAt({}, 0);
        await $table.setActiveRow(row);
      },
      // 删除行
      deleteBtnClickHandler() {
        if (!this.selectionList.length) {
          this.$message.error('请选择行再删除');
          return;
        }
        const XIDList = this.selectionList.map((item) => item._XID);
        const idList = this.selectionList.map((item) => item.id).filter((item) => Boolean(item));
        this.ids = [...this.ids, ...idList];
        this.tableData = this.getTableData().filter((item) => !XIDList.includes(item._XID));
      },
      // 关闭表格
      closeEditTableHandler() {},
      // 获取表格数据
      getValidateTableData() {
        this.closeEditTableHandler();
        return new Promise((resolve, reject) => {
          const $table = this.$refs.xTableRef;
          const tableData = $table.getTableData().fullData;
          $table.validate((valid) => {
            if (valid && tableData.length) {
              const currentStatus = this.$route.query.status;
              const isCopyStatus =
                ['create', 'renew'].includes(currentStatus) && this.contractStatus != '01';
              const formTableData = tableData.map((item) => {
                return {
                  ...item,
                  // departmentCode: this.userInfo.departmentCode,
                  // departmentName: this.userInfo.departmentName,
                  // companyCode: this.userInfo.companyCode,
                  // companyName: this.userInfo.companyName,
                  // 特殊处理id
                  id: isCopyStatus ? null : item?.id,
                  gmtCreate: isCopyStatus ? null : item?.gmtCreate,
                  gmtModified: isCopyStatus ? null : item?.gmtModified,
                };
              });
              resolve({ tableData: formTableData, deleteStorageLineIds: this.ids });
            } else {
              this.$message.error('请填写表格数据');
              reject({ tableData: [], deleteStorageLineIds: [] });
            }
          });
        });
      },
      getTableData() {
        const $table = this.$refs.xTableRef;
        return $table.getTableData().fullData;
      },
      fullTableData(tableData) {
        this.tableData = tableData;
      },
    },
    watch: {
      contractStatus: {
        handler(val) {
          // 如果当前是续签的时候只有主体不可以编辑就是
          const currentStatus = this.$route.query.status;
          if (['-1'].includes(val)) {
            this.editConfig = {};
            this.isHiddenBtn = true;
          } else if (['renew', 'change'].includes(currentStatus)) {
            this.editConfig = { trigger: 'click', mode: 'row' };
            this.isHiddenBtn = false;
          } else if (['create'].includes(currentStatus)) {
            // 拷贝的时候
            this.editConfig = { trigger: 'click', mode: 'row' };
            this.isHiddenBtn = false;
          } else {
            if (['02', '03', '05', '06'].includes(val)) {
              this.editConfig = {};
              this.isHiddenBtn = true;
            } else {
              this.editConfig = { trigger: 'click', mode: 'row' };
              this.isHiddenBtn = false;
            }
          }
        },
        immediate: true,
      },
      fetchTableData: {
        handler(val) {
          if (val && val.length) {
            this.fullTableData(val);
          }
        },
        immediate: true,
      },
    },
    components: {
      ViewImgDialog,
    },
  };
</script>

<style lang="scss" scoped>
  .store-table {
    ::v-deep .vxe-table.size--mini .vxe-body--column.col--ellipsis .vxe-cell {
      max-height: revert !important;
    }
  }
</style>
